import { ManagementActionTypes } from 'types';

export const getCopy = () => ({
  [ManagementActionTypes.bom]: {
    title: 'Delete BOM',
    body: 'Are you sure you want to delete this BOM? You will not be able to undo this action.',
    successMessage: 'BOM successfully deleted',
  },
  [ManagementActionTypes.productionRun]: {
    title: 'Delete Program',
    body: 'Are you sure you want to delete this program? You will not be able to undo this action.',
    successMessage: 'Program successfully deleted',
  },
  [ManagementActionTypes.supplier]: {
    title: 'Delete Supplier',
    body: 'Are you sure you want to delete this supplier? You will not be able to undo this action.',
    successMessage: 'Supplier successfully deleted',
  },
  [ManagementActionTypes.purchaseRule]: {
    title: 'Delete Purchase Rule',
    body: 'Are you sure you want to delete this purchase rule? You will not be able to undo this action.',
    successMessage: 'Purchase rule successfully deleted',
  },
  [ManagementActionTypes.purchaseOrder]: {
    title: 'Delete Purchase Order',
    body: 'Are you sure you want to delete this purchase order? You will not be able to undo this action.',
    successMessage: 'Purchase order successfully deleted',
  },
});
